import { AppProviders } from './AppProviders';
import { RouterProvider } from 'react-router-dom';
import { router } from './routes';

export function App() {
    return (
        <AppProviders>
            <RouterProvider router={router} />
        </AppProviders>
    );
}
